import type { ColumnDef } from '@tanstack/react-table';
import { Checkbox } from '@/components/ui/Checkbox';
import { IoMdRemove } from 'react-icons/io';
import type { File } from '../../../../types/file.types';

export const SelectColumn: ColumnDef<File> = {
  id: 'select',
  header: ({ table }) => {
    return (
      <div className="pointer-events-auto ml-3 mr-5 flex items-center">
        <Checkbox
          name="select-all"
          tabIndex={-1}
          size="md"
          onChange={() => {
            Object.keys(table.getState().rowSelection).length > 0
              ? table.toggleAllPageRowsSelected(false)
              : table.toggleAllPageRowsSelected(true);
          }}
          checked={table.getIsAllPageRowsSelected()}
          additionalStyle={
            table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected()
              ? 'border-none cursor-pointer !bg-primary rounded-[3px] flex items-center justify-center'
              : ''
          }
          customIcon={
            table.getIsSomeRowsSelected() &&
            !table.getIsAllPageRowsSelected() ? (
              <IoMdRemove className="text-white" />
            ) : undefined
          }
        />
      </div>
    );
  },
  cell: ({ row }) => {
    return (
      <div
        className="flex h-10 w-full cursor-default items-center pl-3"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Checkbox
          name="select-file"
          tabIndex={-1}
          size="md"
          onChange={(value) => {
            row.toggleSelected(!!value);
          }}
          checked={row.getIsSelected()}
        />
      </div>
    );
  },
  enableSorting: true,
  enableHiding: true,
  size: 30,
};
